import { AccessTimeFilled } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import { JobDto } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, HighlightedText, useMinimalsTheme } from '@tom-ui/ui'
import { formatContainerNumber, formatDateTime } from '@tom-ui/utils'
import { useMemo } from 'react'

interface Props {
  job: JobDto
  highlightText?: string
  variant?: 'h3' | 'h1'
}
export const JobContainerNumber = ({ job, highlightText, variant }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const displayName: string = useMemo(() => {
    const displayName = job.cargoUnit?.displayName ?? job.suggestedEmptyContainer?.number

    return displayName
      ? formatContainerNumber(displayName)
      : t('noContainerNumber', 'No container no.')
  }, [job.cargoUnit?.displayName, job.suggestedEmptyContainer?.number])

  const hasSuggestedContainerNumber: boolean = useMemo(
    () => !job.cargoUnit?.displayName && !!job.suggestedEmptyContainer?.number,
    [job.cargoUnit?.displayName, job.suggestedEmptyContainer?.number],
  )

  return (
    <Stack>
      <Stack flexDirection='row' alignItems='center' gap={theme.customSpacing.s}>
        <Typography
          variant={variant ?? 'h3'}
          data-cy={`job-card-container-number-${job.cargoUnit?.displayName}`}
        >
          <HighlightedText highlight={highlightText}>{displayName}</HighlightedText>
        </Typography>
        {job.isPriority && <ColoredLabel color='warning' label={t('high', 'High')} />}
        {job.order?.releaseValidityDate && (
          <ColoredLabel
            color='warning'
            startIcon={<AccessTimeFilled fontSize='small' />}
            label={`${t('validTill', 'Valid till')}: ${formatDateTime(job.order.releaseValidityDate)}`}
          />
        )}
      </Stack>
      {hasSuggestedContainerNumber && (
        <Typography variant='body2'>
          {t('suggestedNonNumericContainer', 'Suggested Non numeric container')}
        </Typography>
      )}
    </Stack>
  )
}
